import { Injectable } from '@angular/core';
import { APIService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class PartnerService {
  constructor(
    private apiService: APIService
  ) {}

  /**
   * Service for get a specific partner
   *
   * @param {Object} urlParams
   */
  get(urlParams: Object) {
    return this.apiService
      .post('/srv/partner/getpartner', urlParams);
  }

  /**
   * Service for list all partners
   *
   * @param {Object} urlParams
   */
  getAll(urlParams: Object) {
    return this.apiService
      .post('/srv/partner/listpartners', urlParams);
  }

  /**
   * Service for add a new partner
   *
   * @param {Object} urlParams
   */
  add(urlParams: Object) {
    return this.apiService
      .post('/srv/partner/addpartner', urlParams);
  }

  /**
   * Service for delete a specific partner
   *
   * @param {Object} urlParams
   */
  delete(urlParams: Object) {
    return this.apiService
      .post('/srv/partner/delpartner', urlParams);
  }

  /**
   * Service for update a specific partner
   *
   * @param {Object} urlParams
   */
  update(urlParams: Object) {
    return this.apiService
      .post('/srv/partner/updatepartner', urlParams);
  }

  /**
   * Service for select partner or clear seleted partner
   *
   * @param {Object} urlParams
   */
  select(urlParams?: Object) {
    return this.apiService
      .post('/srv/partner/selectpartner', urlParams);
  }
}
